import {
	Box,
	styled,
} from '@mui/material'

export const PageLoaderRoot = styled(Box, {
	shouldForwardProp: (prop) => {
		return prop !== 'fullScreen'
	},
})<{
	fullScreen?: boolean
}>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	width: 100%;
	height: ${({
		fullScreen,
	}): string => {
		return (fullScreen ?
			'100vh' :
			'100%')
	}};
	min-height: ${({
		fullScreen,
	}): string => {
		return (fullScreen ?
			'100vh' :
			'200px')
	}};
	background-color: #1a1a1a;
`

export const PageLoaderText = styled(Box)`
	color: #cccccc;
	font-size: 14px;
	font-weight: 500;
`
